import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const getMultipartHeaders = () => ({
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
});

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getTestimonialsList = async () => {
  return await axiosInstance.get("testimonials/getlist", { headers });
};

export const getTestimonialById = async (id) => {
  const response = await axiosInstance.get(`testimonials/get/${id}`, { headers });
  return response.data.result;
};

export const addTestimonial = async (formData) => {
  return await axiosInstance.post("testimonials/add", formData, {
    headers: getMultipartHeaders(),
  });
};

export const updateTestimonial = async (formData) => {
  return await axiosInstance.put("testimonials/update", formData, {
    headers: getMultipartHeaders(),
  });
};

export const deleteTestimonial = async (id) => {
  return await axiosInstance.delete(`testimonials/delete/${id}`, { headers });
};
